export const IconList = [
  // externel notion 불필요 -> 주석 처리함. 이후 다시 되살릴 수 있음.

  // {
  //   name: "Notion",
  //   link: "https://www.notion.so/KUBIG-525637dea0aa43d9a7da1bd51e69b153",
  //   icon: () => (
  //     <svg
  //       width="38"
  //       height="38"
  //       viewBox="0 0 38 38"
  //       fill="none"
  //       xmlns="http://www.w3.org/2000/svg"
  //     >
  //       <g clipPath="url(#clip0_505_855)">
  //         <g clipPath="url(#clip1_505_855)">
  //           <path
  //             d="M6.97929 6.93444C8.14695 7.88296 8.58521 7.81096 10.7796 7.66383L31.464 6.42261C31.9022 6.42261 31.5376 5.98435 31.392 5.91235L27.9548 3.42835C27.2974 2.91809 26.4193 2.3327 24.7383 2.47826L4.71129 3.94018C3.9819 4.01218 3.83477 4.37844 4.1259 4.66957L6.97929 6.93444ZM8.22051 11.7553V33.5181C8.22051 34.6873 8.80434 35.1256 10.1207 35.052L32.8523 33.7372C34.1687 33.6652 34.3158 32.8607 34.3158 31.9106V10.2934C34.3158 9.34487 33.9511 8.83305 33.145 8.90505L9.38973 10.2934C8.51321 10.367 8.22051 10.8052 8.22051 11.7537V11.7553ZM30.661 12.9214C30.8066 13.5788 30.661 14.2362 30.0036 14.3113L28.908 14.5304V30.5958C27.9563 31.1077 27.0798 31.4004 26.3489 31.4004C25.1781 31.4004 24.8854 31.0341 24.0089 29.94L16.8449 18.6924V29.5737L19.1113 30.0871C19.1113 30.0871 19.1113 31.4019 17.2831 31.4019L12.24 31.693C12.0944 31.4019 12.24 30.671 12.7518 30.5254L14.0666 30.1607V15.7717L12.2431 15.6245C12.096 14.9671 12.4622 14.0186 13.4843 13.945L18.8937 13.5804L26.3504 24.9736V14.8936L24.4487 14.676C24.3031 13.8715 24.8869 13.2877 25.6179 13.2157L30.661 12.9214ZM3.03025 1.968L23.8633 0.434087C26.4209 0.214957 27.0798 0.360522 28.6873 1.52974L35.3379 6.20348C36.4336 7.00644 36.7998 7.22557 36.7998 8.10209V33.7372C36.7998 35.3431 36.216 36.2948 34.1702 36.4388L9.97512 37.9007C8.44121 37.9743 7.70868 37.7551 6.90416 36.7315L2.0066 30.3767C1.13008 29.2075 0.765381 28.3325 0.765381 27.3089V4.52244C0.765381 3.20922 1.35077 2.112 3.03025 1.968Z"
  //             fill="#fff"
  //           />
  //         </g>
  //       </g>
  //       <defs>
  //         <clipPath id="clip0_505_855">
  //           <rect
  //             width="37.5652"
  //             height="37.5652"
  //             fill="#fff"
  //             transform="translate(0 0.3479)"
  //           />
  //         </clipPath>
  //         <clipPath id="clip1_505_855">
  //           <rect
  //             width="37.5652"
  //             height="37.5652"
  //             fill="#fff"
  //             transform="translate(0 0.3479)"
  //           />
  //         </clipPath>
  //       </defs>
  //     </svg>
  //   ),
  // },
  {
    name: "Instagram",
    link: "https://www.instagram.com/kubig.official/",
    icon: () => (
      <svg
        width="39"
        height="38"
        viewBox="0 0 39 38"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_505_859)">
          <path
            d="M19.3478 3.73024C24.3663 3.73024 24.9606 3.75225 26.9342 3.84029C28.7684 3.921 29.7589 4.22915 30.4193 4.48594C31.2924 4.82344 31.9233 5.23431 32.5763 5.8873C33.2367 6.54763 33.6402 7.17127 33.9777 8.04437C34.2345 8.70469 34.5426 9.70252 34.6233 11.5294C34.7114 13.5104 34.7334 14.1047 34.7334 19.1158C34.7334 24.1343 34.7114 24.7286 34.6233 26.7023C34.5426 28.5365 34.2345 29.527 33.9777 30.1873C33.6402 31.0604 33.2293 31.6914 32.5763 32.3444C31.916 33.0047 31.2924 33.4082 30.4193 33.7457C29.7589 34.0025 28.7611 34.3107 26.9342 34.3914C24.9532 34.4794 24.3589 34.5014 19.3478 34.5014C14.3293 34.5014 13.735 34.4794 11.7614 34.3914C9.92714 34.3107 8.93665 34.0025 8.27633 33.7457C7.40323 33.4082 6.77225 32.9974 6.11926 32.3444C5.45894 31.684 5.0554 31.0604 4.7179 30.1873C4.46111 29.527 4.15296 28.5292 4.07225 26.7023C3.98421 24.7213 3.9622 24.127 3.9622 19.1158C3.9622 14.0974 3.98421 13.5031 4.07225 11.5294C4.15296 9.69518 4.46111 8.70469 4.7179 8.04437C5.0554 7.17127 5.46627 6.54029 6.11926 5.8873C6.77959 5.22698 7.40323 4.82344 8.27633 4.48594C8.93665 4.22915 9.93448 3.921 11.7614 3.84029C13.735 3.75225 14.3293 3.73024 19.3478 3.73024ZM19.3478 0.3479C14.2486 0.3479 13.6103 0.369911 11.6073 0.457955C9.61165 0.545998 8.23964 0.868824 7.05106 1.33105C5.81111 1.81529 4.76193 2.45361 3.72008 3.50279C2.67089 4.54464 2.03258 5.59383 1.54834 6.82643C1.08611 8.02236 0.763283 9.38703 0.67524 11.3827C0.587196 13.393 0.565186 14.0313 0.565186 19.1305C0.565186 24.2297 0.587196 24.868 0.67524 26.871C0.763283 28.8667 1.08611 30.2387 1.54834 31.4273C2.03258 32.6672 2.67089 33.7164 3.72008 34.7582C4.76193 35.8001 5.81111 36.4457 7.04372 36.9226C8.23964 37.3849 9.60432 37.7077 11.6 37.7957C13.603 37.8838 14.2413 37.9058 19.3405 37.9058C24.4396 37.9058 25.078 37.8838 27.0809 37.7957C29.0766 37.7077 30.4486 37.3849 31.6372 36.9226C32.8698 36.4457 33.919 35.8001 34.9608 34.7582C36.0027 33.7164 36.6483 32.6672 37.1252 31.4346C37.5875 30.2387 37.9103 28.874 37.9983 26.8783C38.0864 24.8753 38.1084 24.237 38.1084 19.1378C38.1084 14.0387 38.0864 13.4003 37.9983 11.3974C37.9103 9.40171 37.5875 8.02969 37.1252 6.84111C36.663 5.59382 36.0247 4.54464 34.9755 3.50279C33.9337 2.46094 32.8845 1.81529 31.6519 1.33839C30.4559 0.876161 29.0913 0.553335 27.0956 0.465292C25.0853 0.369911 24.447 0.3479 19.3478 0.3479Z"
            fill="#fff"
          />
          <path
            d="M19.3478 9.48242C14.0212 9.48242 9.69971 13.8039 9.69971 19.1305C9.69971 24.4571 14.0212 28.7786 19.3478 28.7786C24.6744 28.7786 28.9959 24.4571 28.9959 19.1305C28.9959 13.8039 24.6744 9.48242 19.3478 9.48242ZM19.3478 25.3889C15.8921 25.3889 13.0894 22.5862 13.0894 19.1305C13.0894 15.6748 15.8921 12.8721 19.3478 12.8721C22.8035 12.8721 25.6062 15.6748 25.6062 19.1305C25.6062 22.5862 22.8035 25.3889 19.3478 25.3889Z"
            fill="#fff"
          />
          <path
            d="M31.6299 9.10084C31.6299 10.3481 30.6174 11.3533 29.3774 11.3533C28.1302 11.3533 27.125 10.3408 27.125 9.10084C27.125 7.85355 28.1375 6.84839 29.3774 6.84839C30.6174 6.84839 31.6299 7.86089 31.6299 9.10084Z"
            fill="#fff"
          />
        </g>
        <defs>
          <clipPath id="clip0_505_859">
            <rect
              width="37.5652"
              height="37.5652"
              fill="#fff"
              transform="translate(0.565186 0.3479)"
            />
          </clipPath>
        </defs>
      </svg>
    ),
  },
  {
    name: "Github",
    link: "https://github.com/KU-BIG",
    icon: () => (
      <svg
        width="38"
        height="38"
        viewBox="0 0 38 38"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_505_864)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.9134 1.13062C14.4545 1.13293 10.1417 2.7122 6.74635 5.58604C3.35098 8.45988 1.0944 12.4409 0.380104 16.8172C-0.334197 21.1936 0.540354 25.6798 2.8474 29.4738C5.15444 33.2679 8.74352 36.1222 12.9729 37.5266C13.9059 37.6998 14.2574 37.1215 14.2574 36.6297C14.2574 36.138 14.2387 34.7124 14.2325 33.1537C9.00735 34.2825 7.90323 30.9488 7.90323 30.9488C7.05103 28.784 5.81938 28.215 5.81938 28.215C4.11498 27.0584 5.94691 27.08 5.94691 27.08C7.83481 27.213 8.82697 29.0067 8.82697 29.0067C10.5003 31.8611 13.2217 31.0354 14.2916 30.5529C14.4596 29.3437 14.9479 28.5211 15.4859 28.0542C11.312 27.5841 6.92662 25.9822 6.92662 18.8261C6.90075 16.9702 7.59337 15.1754 8.86118 13.8131C8.66835 13.343 8.02452 11.4442 9.04467 8.86503C9.04467 8.86503 10.6216 8.36404 14.2108 10.7793C17.2893 9.9422 20.5375 9.9422 23.6161 10.7793C27.2021 8.36404 28.7759 8.86503 28.7759 8.86503C29.7992 11.438 29.1554 13.3368 28.9625 13.8131C30.2343 15.1756 30.9284 16.9735 30.9002 18.8322C30.9002 26.0038 26.5054 27.5841 22.3253 28.0449C22.9971 28.6263 23.5974 29.7612 23.5974 31.5054C23.5974 34.0042 23.5756 36.0143 23.5756 36.6297C23.5756 37.1276 23.9146 37.709 24.8664 37.5266C29.0962 36.1221 32.6856 33.2672 34.9927 29.4725C37.2997 25.6779 38.1738 21.1909 37.4586 16.8142C36.7435 12.4374 34.4858 8.45639 31.0893 5.58304C27.6928 2.70969 23.3791 1.13146 18.9196 1.13062H18.9134Z"
            fill="#fff"
          />
          <path
            d="M7.24351 27.9458C7.20307 28.0386 7.05378 28.0664 6.93249 28.0015C6.81119 27.9365 6.721 27.8159 6.76454 27.72C6.80808 27.6242 6.95426 27.5994 7.07556 27.6644C7.19686 27.7293 7.29016 27.853 7.24351 27.9458Z"
            fill="#fff"
          />
          <path
            d="M8.00522 28.79C7.94081 28.8223 7.86712 28.8313 7.79677 28.8155C7.72641 28.7997 7.66377 28.7601 7.61956 28.7034C7.49826 28.5736 7.47336 28.3942 7.56667 28.3138C7.65998 28.2334 7.82794 28.2705 7.94924 28.4004C8.07054 28.5303 8.09853 28.7096 8.00522 28.79Z"
            fill="#fff"
          />
          <path
            d="M8.74579 29.8632C8.63071 29.9436 8.43475 29.8632 8.32589 29.7024C8.29579 29.6736 8.27186 29.639 8.25551 29.6007C8.23915 29.5624 8.23071 29.5213 8.23071 29.4797C8.23071 29.4382 8.23915 29.397 8.25551 29.3588C8.27186 29.3205 8.29579 29.2859 8.32589 29.2571C8.44097 29.1798 8.63693 29.2571 8.74579 29.4148C8.85464 29.5725 8.85775 29.7828 8.74579 29.8632Z"
            fill="#fff"
          />
          <path
            d="M9.75027 30.9024C9.64763 31.0168 9.43925 30.9859 9.26819 30.8313C9.09713 30.6767 9.05669 30.4664 9.15932 30.355C9.26196 30.2437 9.47035 30.2746 9.64763 30.4262C9.82491 30.5777 9.85913 30.7911 9.75027 30.9024Z"
            fill="#fff"
          />
          <path
            d="M11.1592 31.5086C11.1126 31.6539 10.9011 31.7189 10.6896 31.657C10.4781 31.5952 10.3381 31.422 10.3785 31.2735C10.419 31.1251 10.6336 31.0571 10.8482 31.1251C11.0628 31.1931 11.1996 31.357 11.1592 31.5086Z"
            fill="#fff"
          />
          <path
            d="M12.6957 31.6135C12.6957 31.765 12.5215 31.8949 12.2976 31.898C12.0736 31.9011 11.8901 31.7774 11.8901 31.6259C11.8901 31.4743 12.0643 31.3445 12.2882 31.3414C12.5122 31.3383 12.6957 31.4589 12.6957 31.6135Z"
            fill="#fff"
          />
          <path
            d="M14.1265 31.3754C14.1544 31.5269 13.9989 31.6846 13.775 31.7217C13.5511 31.7588 13.3551 31.6691 13.3271 31.5207C13.2991 31.3723 13.4609 31.2115 13.6786 31.1713C13.8963 31.1311 14.0985 31.2238 14.1265 31.3754Z"
            fill="#fff"
          />
        </g>
        <defs>
          <clipPath id="clip0_505_864">
            <rect
              width="37.5652"
              height="37.5652"
              fill="#fff"
              transform="translate(0.130371 0.3479)"
            />
          </clipPath>
        </defs>
      </svg>
    ),
  },
  {
    name: "Email",
    link: "kubigkorea@gmail.com",
    icon: () => (
      <svg
        width="43"
        height="43"
        viewBox="0 0 43 43"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_505_873)">
          <path
            d="M6.56519 15.2608C6.56519 13.0473 6.56519 11.9405 7.25285 11.2528C7.94051 10.5652 9.04729 10.5652 11.2608 10.5652H32.3913C34.6048 10.5652 35.7116 10.5652 36.3993 11.2528C37.0869 11.9405 37.0869 13.0473 37.0869 15.2608V28.1739C37.0869 30.3874 37.0869 31.4942 36.3993 32.1819C35.7116 32.8695 34.6048 32.8695 32.3913 32.8695H11.2608C9.04729 32.8695 7.94051 32.8695 7.25285 32.1819C6.56519 31.4942 6.56519 30.3874 6.56519 28.1739V15.2608Z"
            stroke="#fff"
            strokeWidth="2.34783"
          />
          <path
            d="M8.67798 11.269L16.191 16.9038C18.9041 18.9386 20.2606 19.956 21.8258 19.956C23.391 19.956 24.7475 18.9386 27.4606 16.9038L34.9736 11.269"
            stroke="#fff"
            strokeWidth="2.34783"
          />
        </g>
        <defs>
          <clipPath id="clip0_505_873">
            <rect
              width="42.2609"
              height="42.2609"
              fill="#fff"
              transform="translate(0.695557)"
            />
          </clipPath>
        </defs>
      </svg>
    ),
  },
];
